"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeAppProcess = exports.buildFunctionCallerFromCallbacks = void 0;
const Runtime_1 = require("../types/Runtime");
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const executeProcessesFactory_1 = __importDefault(require("./executeProcessesFactory"));
const createRunnableProcess_1 = __importDefault(require("../shared/createRunnableProcess"));
const createEmptyFunctionOutputs_1 = __importDefault(require("../shared/createEmptyFunctionOutputs"));
const buildFunctionCaller = ({ processor, appProcessFunctionId, processes, lastFunctionsOutputs, itemContext, controlCallerId, }) => ({ entryVars: { returnData }, eventOutputs, }) => {
    (0, executeProcessesFactory_1.default)({
        lastFunctionsOutputs,
        processor,
        controlCallerId,
        eventOutputs,
        itemContext,
    })(appProcessFunctionId, processes, returnData);
};
const buildFunctionCallerFromCallbacks = (appProcessFunctionId, callbacks, processor, lastFunctionsOutputs, itemContext, controlCallerId) => {
    const functionsFromAppProcessCallbacksCallbacks = {};
    Object.entries(callbacks || {}).forEach(([callbackKey, processes]) => {
        if ((0, valueIsUndefined_1.default)(processes)) {
            return;
        }
        functionsFromAppProcessCallbacksCallbacks[`${Runtime_1.SPECIAL_CALLBACK_NAMES.PREFIX}${callbackKey}`] = buildFunctionCaller({
            processor,
            appProcessFunctionId,
            processes,
            lastFunctionsOutputs,
            itemContext,
            controlCallerId,
        });
    });
    return functionsFromAppProcessCallbacksCallbacks;
};
exports.buildFunctionCallerFromCallbacks = buildFunctionCallerFromCallbacks;
const executeAppProcess = (functionDefinitions) => async ({ functionsFromAppProcessCallbacksCallbacks, processor, entryVars, appProcessId, itemContext = {}, eventOutputs, }) => {
    var _a, _b;
    const buildOrders = processor.root.getBuildOrders();
    const newProcessor = processor.copyProcessorWithContext(entryVars);
    const processFunctionsList = ((_b = (_a = buildOrders === null || buildOrders === void 0 ? void 0 : buildOrders.appProcesses) === null || _a === void 0 ? void 0 : _a[appProcessId]) === null || _b === void 0 ? void 0 : _b.functions) || [];
    const processes = processFunctionsList
        .reduce((result, processId) => {
        const process = (0, createRunnableProcess_1.default)({
            processor,
            functionId: processId,
            functions: (buildOrders === null || buildOrders === void 0 ? void 0 : buildOrders.functions) || {},
            extraFunctionDefinitions: functionsFromAppProcessCallbacksCallbacks,
            functionDefinitions,
        });
        if (process) {
            result.push(process);
        }
        return result;
    }, []);
    await (0, executeProcessesFactory_1.default)({
        processor: newProcessor,
        itemContext,
        lastFunctionsOutputs: (0, createEmptyFunctionOutputs_1.default)(),
        eventOutputs,
    })(undefined, processes);
};
exports.executeAppProcess = executeAppProcess;
exports.default = () => undefined;
